export const TEST_ID_MULTI_SELECTOR = {
    SINGLE_VALUE: 'multi-selector-single-value',
    OPTION_WITH_EDIT_AND_DELETE: 'option-with-edit-and-delete-test-id',
    DELETE_TAG_GROUP_MODAL: 'delete-tag-group-modal',
};

export const CAMPAIGN_TABLE_NOTIFICATIONS = {
    CREATE_TAGS_GROUP: {
        SUCCESSFUL: 'Tags Group created sucessfully!',
        ERROR: 'An error occurred while creating this group of tags',
    },
    UPDATE_TAGS_GROUP: {
        SUCCESSFUL: 'Tags Group updated successfully!',
        ERROR: 'An error occurred while updating this group of tags',
    },
    DELETE_TAGS_GROUP: {
        SUCCESSFUL: 'Tags Group deleted successfully!',
        ERROR: 'Something went wrong while deleting this group of tags',
    },
    LOAD_TAGS_GROUP: {
        ERROR: 'Something went wrong while loading tags for selector accordion',
    },
    BLANK_NAME_TAGS_GROUP: {
        ERROR: 'Please, fill a valid name for this group of tags',
    },
};
